import {
  SYNC_APP_CONFIG,
  UPDATE_APP_CONFIG,
  UPDATE_APP_CONFIG_COMPLETE
} from '../actions/types';

//user state can be false (if not logged in), authenticating (if currently fetching user), or the user{} object

const DEFAULT_STATE = {
  loading: true,
  saving: false,
  error: null,
  data: null,
}

export default function(state = DEFAULT_STATE, action){
  switch(action.type){
    case SYNC_APP_CONFIG:
      return {
        ...state,
        saving: false,
        loading: false,
        data: action.payload
      }
    case UPDATE_APP_CONFIG:
      return {
        ...state,
        saving: true
      }
    case UPDATE_APP_CONFIG_COMPLETE:
      return {
        ...state,
        saving: false
      }
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/appConfigReducer.js